var _namedview, _namedview2, _g, _g2, _g3, _g4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStraightTuckEndTemplate = function SvgStraightTuckEndTemplate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "197.5mm",
    height: "190.0mm",
    viewBox: "-4.5 24.0 197.5 190.0",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _namedview || (_namedview = /*#__PURE__*/React.createElement("namedview", {
    bordercolor: "#666666",
    borderopacity: 1,
    gridtolerance: 10,
    guidetolerance: 10,
    objecttolerance: 10,
    pagecolor: "#ffffff",
    showgrid: "false"
  })), _namedview2 || (_namedview2 = /*#__PURE__*/React.createElement("namedview", {
    bordercolor: "#666666",
    borderopacity: 1,
    gridtolerance: 10,
    guidetolerance: 10,
    objecttolerance: 10,
    pagecolor: "#ffffff",
    showgrid: "false"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 65,
    y1: 74,
    y2: 164,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99,
    x2: 99,
    y1: 74,
    y2: 164,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154,
    x2: 154,
    y1: 74,
    y2: 164,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188,
    x2: 188,
    y1: 74,
    y2: 164,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 10.5,
    y1: 74,
    y2: 75,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    x2: 10.5,
    y1: 80,
    y2: 75,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    x2: 10,
    y1: 163,
    y2: 164,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    x2: 10.5,
    y1: 158,
    y2: 163,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    x2: 10.5,
    y1: 75,
    y2: 163,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    x2: 0.5,
    y1: 80,
    y2: 158,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 65,
    y1: 73,
    y2: 73,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 10,
    y1: 40,
    y2: 74,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 16.4,
    y1: 40,
    y2: 40,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.4,
    x2: 16.4,
    y1: 40,
    y2: 41,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M 11,40 Q 11,29 23.4,29"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 65,
    y1: 40,
    y2: 74,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.599998,
    x2: 65,
    y1: 40,
    y2: 40,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.599998,
    x2: 58.599998,
    y1: 40,
    y2: 41,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M 64,40 Q 64,29 51.6,29"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.4,
    x2: 58.599998,
    y1: 41,
    y2: 41,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.4,
    x2: 51.599998,
    y1: 29,
    y2: 29,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98,
    x2: 99,
    y1: 74,
    y2: 74,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98,
    x2: 98,
    y1: 67.199997,
    y2: 74,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94,
    x2: 98,
    y1: 63.200001,
    y2: 67.199997,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.199997,
    x2: 94,
    y1: 51,
    y2: 63.200001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.400002,
    x2: 65,
    y1: 71.599998,
    y2: 74,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.400002,
    x2: 67.400002,
    y1: 51,
    y2: 71.599998,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.400002,
    x2: 91.199997,
    y1: 51,
    y2: 51,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 98,
    y1: 74,
    y2: 74,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154,
    x2: 155,
    y1: 74,
    y2: 74,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155,
    x2: 155,
    y1: 67.199997,
    y2: 74,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159,
    x2: 155,
    y1: 63.200001,
    y2: 67.199997,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.8,
    x2: 159,
    y1: 51,
    y2: 63.200001,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.60001,
    x2: 188,
    y1: 71.599998,
    y2: 74,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.60001,
    x2: 185.60001,
    y1: 51,
    y2: 71.599998,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.8,
    x2: 184.60001,
    y1: 51,
    y2: 51,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155,
    x2: 188,
    y1: 74,
    y2: 74,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99,
    x2: 154,
    y1: 74,
    y2: 74,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 65,
    y1: 165,
    y2: 165,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 10,
    y1: 164,
    y2: 198,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 16.4,
    y1: 198,
    y2: 198,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.4,
    x2: 16.4,
    y1: 197,
    y2: 198,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "m 11,198 q 0,11 12.4,11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 65,
    y1: 164,
    y2: 198,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.599998,
    x2: 65,
    y1: 198,
    y2: 198,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.599998,
    x2: 58.599998,
    y1: 197,
    y2: 198,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "m 64,198 q 0,11 -12.4,11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.4,
    x2: 58.599998,
    y1: 197,
    y2: 197,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.4,
    x2: 51.599998,
    y1: 209,
    y2: 209,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98,
    x2: 99,
    y1: 164,
    y2: 164,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98,
    x2: 98,
    y1: 164,
    y2: 170.8,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94,
    x2: 98,
    y1: 174.8,
    y2: 170.8,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.199997,
    x2: 94,
    y1: 187,
    y2: 174.8,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 67.400002,
    y1: 164,
    y2: 166.39999,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.400002,
    x2: 68.400002,
    y1: 166.39999,
    y2: 187,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.400002,
    x2: 91.199997,
    y1: 187,
    y2: 187,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 98,
    y1: 164,
    y2: 164,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154,
    x2: 155,
    y1: 164,
    y2: 164,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155,
    x2: 155,
    y1: 164,
    y2: 170.8,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155,
    x2: 159,
    y1: 170.8,
    y2: 174.8,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159,
    x2: 161.8,
    y1: 174.8,
    y2: 187,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.60001,
    x2: 188,
    y1: 166.39999,
    y2: 164,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.60001,
    x2: 185.60001,
    y1: 187,
    y2: 166.39999,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.8,
    x2: 184.60001,
    y1: 187,
    y2: 187,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155,
    x2: 188,
    y1: 164,
    y2: 164,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99,
    x2: 154,
    y1: 164,
    y2: 164,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "height",
    fill: "#000",
    stroke: "#000",
    display: "inline"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 103.91734,
    x2: 103.91734,
    y1: 74,
    y2: 164,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.91734,
    x2: 102.91734,
    y1: 74,
    y2: 78,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.91734,
    x2: 104.91734,
    y1: 74,
    y2: 78,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.91734,
    x2: 102.91734,
    y1: 164,
    y2: 160,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.91734,
    x2: 104.91734,
    y1: 164,
    y2: 160,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: -121,
    y: 108.91743,
    strokeWidth: 0,
    fontSize: "4px",
    textAnchor: "middle",
    transform: "rotate(-90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontSize: "5.64444458px"
  }, " Height ")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "depth",
    fill: "#000",
    stroke: "#000",
    display: "inline"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 99,
    y1: 88.050018,
    y2: 88.050018,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99,
    x2: 95,
    y1: 88.050018,
    y2: 87.050018,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99,
    x2: 95,
    y1: 88.050018,
    y2: 89.050018,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 69,
    y1: 88.050018,
    y2: 87.050018,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 69,
    y1: 88.050018,
    y2: 89.050018,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 82.766663,
    y: 86.050018,
    strokeWidth: 0,
    fontSize: "4px",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontSize: "5.64444458px"
  }, " Depth ")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "width",
    fill: "#000",
    stroke: "#000",
    display: "inlinel"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 65,
    y1: 88.108353,
    y2: 88.108353,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 14,
    y1: 88.108353,
    y2: 87.108353,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 14,
    y1: 88.108353,
    y2: 89.108353,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 37.208328,
    y: 86.108353,
    strokeWidth: 0.1,
    fontSize: "4px",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontSize: "5.64444458px"
  }, " Width ")), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 61,
    y1: 88.108353,
    y2: 87.108353,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    x2: 61,
    y1: 88.108353,
    y2: 89.108353,
    strokeWidth: 0.5
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStraightTuckEndTemplate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/straight-tuck-end-template.a98f8928.svg";
export { ForwardRef as ReactComponent };